var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuConversations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu-conversations") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-conversations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.500000, 2.500000)",
    stroke: "#646464",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4018526,7.77366578 C17.4664917,7.44213912 17.5,7.10271745 17.5,6.75724031 C17.5,3.02531954 13.5899849,7.99360578e-15 8.76673694,7.99360578e-15 C3.94348893,7.99360578e-15 0.0334738727,3.02531954 0.0334738727,6.75724031 C0.0334738727,8.77912353 1.18116688,10.5936006 2.99998352,11.8319325 C3.21773634,11.9801884 2.86758568,12.5171771 2.11182253,13.57554 C1.35605938,14.633903 -0.251557409,14.8563969 0.0334738727,14.9799062 C0.283214031,15.0881233 2.86239338,14.7481473 4.37911198,14.2268403 C4.53493591,14.1732825 4.68033705,14.1204188 4.81581149,14.0686926",
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0114768,18.0096537 C16.3188468,18.0096537 19,15.9927741 19,13.5048269 C19,11.0168797 16.3188468,9 13.0114768,9 C9.7041067,9 7.02295351,11.0168797 7.02295351,13.5048269 C7.02295351,14.852749 7.809943,16.0624004 9.05713156,16.887955 C9.20644777,16.9867923 8.96634447,17.3447847 8.44810688,18.05036 C7.92986929,18.7559353 6.82750349,18.9042646 7.02295351,18.9866042 C7.19420391,19.0587489 8.96278403,18.8320982 10.0028196,18.4845602 C11.0257156,18.1427496 11.3936204,17.8433459 11.4049779,17.8457192 C11.4154292,17.8479033 11.4258921,17.8500665 11.4363664,17.8522089 C11.9382583,17.9548651 12.4663619,18.0096537 13.0114768,18.0096537 Z",
    id: "Oval",
    transform: "translate(13.000000, 14.000000) scale(-1, 1) translate(-13.000000, -14.000000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuConversations);
export default __webpack_public_path__ + "static/media/menu-conversations.d95df90f14e8a470d1b823f2ee9f91bd.svg";
export { ForwardRef as ReactComponent };